<template>
  <div class="warp">
    <div class="warp-item">
      <Pie :viewLeft="viewLeft[0]"></Pie>
      <Pie :viewLeft="viewLeft[1]"></Pie>
    </div>
    <div class="warp-item">
      <cylinder :viewCentre="viewCentre[0]"></cylinder>
      <cylinder :viewCentre="viewCentre[1]"></cylinder>
    </div>
    <div class="warp-item">
      <PieBar :viewRight="viewRight[0]"></PieBar>
      <PieBar :viewRight="viewRight[1]"></PieBar>
    </div>
  </div>
</template>

<script>
import Pie from "@/components/Pie.vue";
import cylinder from "@/components/cylinder.vue";
import PieBar from "@/components/PieBar.vue";
export default {
  name: "dataIndex",
  components: {
    Pie,
    cylinder,
    PieBar,
  },
  data() {
    return {
      viewLeft: [
        {
          item_name: "居民签约统计",
          item_xdata: ["是", "否"],
          series_data: [
            { value: 5, name: "是" },
            { value: 4, name: "否" },
          ],
          colorList: ["#91cc75", "#5875d0"],
        },
        {
          item_name: "婚姻状况统计",
          item_xdata: ["已婚", "未婚"],
          series_data: [
            { value: 3, name: "已婚" },
            { value: 6, name: "未婚" },
          ],
          colorList: ["#ff7f27", "#ffca18"],
        },
      ],
      viewCentre: [
        {
          item_name: "行政区划统计",
          item_xdata: [
            "上桥镇",
            "高闸镇",
            "利通区",
            "郭家桥乡",
            "东塔寺乡",
            "巴浪湖农场",
            "金星镇",
            "板桥乡",
          ],
          series_data: [1, 1, 1, 1, 1, 2, 2, 1, 1],
          colorList: ["#ff7f27", "#5875d0"],
        },
        {
          item_name: "医院好评数量统计",
          item_xdata: [
            "吴忠市人民医院",
            "友爱医院",
            "吴忠黄河医院",
            "吴忠市新区医院",
          ],
          series_data: [10, 1, 4, 6],
          colorList: ["#ff7f27", "#91cc75"],
        },
      ],
      viewRight: [
        {
          item_name: "居民病史统计",
          item_xdata: ["无", "心脏病"],
          series_data: [
            { value: 8, name: "无" },
            { value: 1, name: "心脏病" },
          ],
          colorList: ["#ffaec8", "#b83dba"],
        },
        {
          item_name: "残疾病患统计",
          item_xdata: ["无", "有"],
          series_data: [
            { value: 8, name: "无" },
            { value: 1, name: "有" },
          ],
          colorList: ["#2ec7c9", "#b6a2de"],
        },
      ],
      screenWidth: 0,
      screenHeight: 0,
    };
  },
  mounted() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    const warp = document.querySelector(".warp");
    if (warp) {
      warp.style.width = this.screenWidth + "px";
      warp.style.height = (this.screenHeight - 65) + "px";
    }
  },
  methods: {},
};
</script>

<style scoped>
.warp {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.warp-item {
  width: 30.5%;
}
</style>
